module.exports = __webpack_public_path__ + "images/Doneb84db3a92f512e46fe25a2d273fa628b.gif";